<template>
  <vs-table v-if="show" :params="params" :options="options"></vs-table>
</template>

<script>
import VsTable from "../_framework/VsTable.vue";

export default {
  name: "units",
  created: () => {},
  beforeMount() {
    this.options.access = checkAccess(this.$route.path);
    //console.log(this.options.access);
    this.show = this.options.access ? true : false;
  },
  components: {
    VsTable
  },
  data() {
    return {
      show: true,
      access: {},
      params: {
        entity: "units",
        list: [],
        headers: {
          unitName: {
            title: "عنوان واحد",
            type: "text"
          },
          unitValue: {
            title: "مقدار واحد",
            type: "text"
          }
        }
      },
      options: {
        hasActions: true,
        hasActionsInHeader: true,
        test: "original",
        beforeDeleteEntity: input => {
          this.refreshTable();
          return input;
        },
        beforCreateEntity: input => {
          this.refreshTable();
          return input;
        },
        beforeUpdateEntity: input => {
          this.refreshTable();
          return input;
        },
        getTopRightButtons: () => {
          let arr = [];
          let searchToggleButton = {
            component: "search-toggle-button"
          };
          arr.push(searchToggleButton);
          return arr;
        },
        getTopLeftButtons: () => {
          let arr = [];
          let self = this;
          let addItemButton = {
            component: "toggle-table-actions-button",
            params: {
              onClick() {
                self.options.hasActions = !self.options.hasActions;
              }
            }
          };
          arr.push(addItemButton);
          return arr;
        }
      }
    };
  },
  methods: {
    refreshTable() {
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 50);
    }
  }
};
</script>